/**
 * Reusable Status Badge UI Component
 */

export type BadgeVariant = "success" | "error" | "warning" | "info" | "default";

export interface StatusBadgeProps {
  readonly variant?: BadgeVariant;
  readonly children: React.ReactNode;
  readonly className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  success: "bg-transparent text-green-600 border-green-600",
  error: "bg-transparent text-red-600 border-red-600",
  warning: "bg-transparent text-yellow-600 border-yellow-600",
  info: "bg-transparent text-blue-600 border-blue-600",
  default: "bg-transparent text-gray-600 border-gray-600",
};

export const StatusBadge = ({
  variant = "default",
  children,
  className = "",
}: StatusBadgeProps): React.JSX.Element => {
  const variantClasses = variantStyles[variant];

  return (
    <span
      className={`inline-flex items-center px-4 py-2 rounded-lg text-xs font-semibold border-2 ${variantClasses} ${className}`}
    >
      {children}
    </span>
  );
};
